module.exports = __webpack_public_path__ + "static/logo-vertical-dark-500x410-246db2e7575df8b4ea19df062006dfe0.png";